import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { DeleteConfirmationPopupComponent } from '../delete-confirmation-popup/delete-confirmation-popup.component';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuComponent } from '../menu/menu.component';
import { BusinessMenu } from 'src/app/models/register-business';
import { KeyTitleModel } from 'src/app/models/key-value-model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-menu-section',
  templateUrl: './menu-section.component.html',
  styleUrls: ['./menu-section.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MenuSectionComponent implements OnDestroy {
  @Input() showButtons: boolean = true;
  @Input() product: BusinessMenu;
  @Input() menuTypes: KeyTitleModel[];
  @Input() productImageId: number = 0;
  @Input() businessPartnerId: number;
  @ViewChild('deleteTemplate')
  deleteConfirmationPopupComponent!: DeleteConfirmationPopupComponent;
  @ViewChild('menu') menuComponent!: MenuComponent;
  id: number;
  @Output() productDeleted = new EventEmitter<number>();
  @Output() productUpdated = new EventEmitter<any>();
  @Input() currencySymbol: string;
  private modalRef!: NgbModalRef;
  private menuSubscription!: Subscription;

  constructor(private modalService: NgbModal) { }

  ngOnDestroy(): void {
    if (this.menuSubscription) {
      this.menuSubscription.unsubscribe();
    }
  }

  openMenuItemModal(
    menuItemModal: TemplateRef<any>,
    windowClass = '',
    size = '',
    id?: number
  ) {
    if (menuItemModal == this.menuComponent.menuModalTemplate) {
      this.menuComponent.setDishValues(this.product);

      this.menuSubscription = this.menuComponent.saveMenuSuccess.subscribe(() => {
        this.closeMenuModal();
      });
    }
    const branchId = Number(localStorage.getItem('branchId'));
    if (branchId != 0) {
      const modalOptions = {
        windowClass: windowClass,
        centered: true,
        size: size,
        id: id
      } as NgbModalOptions;
      this.modalRef = this.modalService.open(menuItemModal, modalOptions);
    }
  }

  closeMenuModal = () => {
    if (this.modalRef) {
      this.modalRef.close('Saved');
    }
  }

  menuDeleted(event) {
    this.productDeleted.emit(event);
  }

  menuUpdated(event) {
    this.productUpdated.emit(event);
  }
}
